/** Options are the same entry when they stand for the same value; the label may differ by formatter. */
export const areOptionsEqual = (a, b) => a.value === b.value;
/**
 * What a bulk removal leaves behind. A fixed option survives it: the list is not what decides whether
 * it belongs, which is also why its row offers no remove button of its own.
 */
export const keepAfterBulkRemove = (selected, removed) => selected.filter((option) => option.fixed || !removed.some((item) => areOptionsEqual(option, item)));
